import './styles/tokens.css'
import './styles/components.css'
import './styles/tailwind.css'
import './styles/pages.css'
import './i18n/index.js'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { SettingsProvider } from './api/settings'
import { ToastProvider } from './components/Toast'
import { applyImpersonationFromUrl } from './api/auth'
import { registerServiceWorker, refreshPushSubscription } from './api/push'
import './utils/installPrompt' // side effect: capture beforeinstallprompt early

// Swap in an impersonation token (?impersonate=…) before any provider reads the
// session, so settings/fleet load as the impersonated org from the first fetch.
applyImpersonationFromUrl()

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Capture every transaction while the fleet is small; tune down later.
    tracesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
  });
}


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SettingsProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </SettingsProvider>
  </StrictMode>
)

// Register the PWA service worker (offline shell + web push) once the page has
// loaded, so it never competes with first paint. If the user already granted
// push, re-sync the subscription (the browser can silently rotate its endpoint).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerServiceWorker().then(() => { refreshPushSubscription() })
  })
}
